module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-other.svg?f8f50429cc2aafec4f6be2081b2adcad";